import { render } from "./KonfirmasiModal_c.vue?vue&type=template&id=2cc621c4&scoped=true"
import script from "./KonfirmasiModal_c.vue?vue&type=script&lang=js"
export * from "./KonfirmasiModal_c.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2cc621c4"

export default script